// V2 原文定位接口（支持专利和自由文本）
export interface ApiGetResultPositionRequest {
    // V2 文件类型（必填）
    file_type: 'patent' | 'freetext';

    // V1 风格参数（必填）
    source_text: string;              // 待定位的文本内容
    source_patent: string;            // 专利ID（file_type=patent时使用，freetext时可传空字符串）
    source_lang: string;              // 内容语言

    // 专利场景参数（条件必填：file_type=patent时必须传）
    target_type?: 'CLAIM' | 'DESC';   // CLAIM=权利要求，DESC=说明书

    // 自由文本场景参数（条件必填：file_type=freetext时必须传）
    origin_text?: string;             // 完整原文
}

export interface ApiGetResultPositionResponse {
    match_text: string[];             // 匹配到的文本列表（可能有多处）
    original_text?: string;           // 完整原文（如果后端返回）
}

export const GetResultPosition = Symbol.for('GetResultPosition');

export interface GetResultPosition {
    getResultPosition(request: ApiGetResultPositionRequest): Promise<ApiGetResultPositionResponse>;
}
